const smoothScroll = (
  targetPosition: number,
  duration: number,
  referenceElement: HTMLElement | Window
) => {
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;
  let startTime: number | null = null;

  const animation = (currentTime: number) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
    referenceElement.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  const easeInOutQuad = (
    currentTime: number,
    startValue: number,
    changeInValue: number,
    duration: number
  ) => {
    currentTime /= duration / 2;
    if (currentTime < 1)
      return (changeInValue / 2) * currentTime * currentTime + startValue;
    currentTime--;
    return (
      (-changeInValue / 2) * (currentTime * (currentTime - 2) - 1) + startValue
    );
  };

  requestAnimationFrame(animation);
};

export default smoothScroll;
